import DocsApp, {
    readStoredThemePreference
} from "./src/app";
import {
    readBlockViewParams,
    getBlockViewId
} from "./src/blocks/settings";
import BlockView from "./src/blocks/view";
import CreatePreview from "./src/create/preview";
import {
    CREATE_VIEW_ID
} from "./src/create/settings";
import {
    getFontCss
} from "./src/fonts";
import {
    readStoredLanguage,
    DocsI18nProvider,
    getKitLocale
} from "./src/i18n";
import {
    DocsRouterProvider,
    parseDocsPathname
} from "./src/router";
import {
    resolveTheme
} from "./src/theme";
import {
    type NCoreUIKitConfig,
    setupNCoreUIKit
} from "ncore-ui-kit";
import {
    createRoot
} from "react-dom/client";

const FONT_PRELOADS = [
    "400 1em Geist",
    "500 1em Geist",
    "600 1em Geist",
    "400 1em \"Geist Mono\""
];

const FONT_WAIT_LIMIT = 1000;

const styleElement = document.createElement("style");

styleElement.setAttribute("data-docs", "true");

styleElement.textContent = getFontCss();

document.head.appendChild(styleElement);

const blockViewId = getBlockViewId(window.location.pathname);

const blockViewLanguage = readBlockViewParams(window.location.search).language ?? readStoredLanguage();

const routeLanguage = parseDocsPathname(window.location.pathname).language ?? readStoredLanguage();

const NCoreConfig: NCoreUIKitConfig = {
    initialSelectedTheme: blockViewId ? "light" : resolveTheme(readStoredThemePreference()),
    initialSelectedLocale: getKitLocale(blockViewId ? blockViewLanguage : routeLanguage),
    initialSelectedGapPropagation: "spacious",
    initialSelectedPalette: "nibgat"
};

const NCoreUIKitBase = setupNCoreUIKit(NCoreConfig);

const handleRender = () => {
    const container = document.getElementById("docs-root");

    if(!container) {
        return;
    }

    if(blockViewId) {
        createRoot(container).render(<NCoreUIKitBase.Provider>
            <DocsI18nProvider
                initialLanguage={blockViewLanguage}
            >
                {
                    blockViewId === CREATE_VIEW_ID ?
                        <CreatePreview/>
                    :
                        <BlockView
                            id={blockViewId}
                        />
                }
            </DocsI18nProvider>
        </NCoreUIKitBase.Provider>);

        return;
    }

    createRoot(container).render(<NCoreUIKitBase.Provider>
        <DocsI18nProvider
            initialLanguage={routeLanguage}
        >
            <DocsRouterProvider>
                <DocsApp/>
            </DocsRouterProvider>
        </DocsI18nProvider>
    </NCoreUIKitBase.Provider>);
};

Promise.race([
    Promise.all(FONT_PRELOADS.map((font) => document.fonts.load(font))),
    new Promise((resolve) => {
        setTimeout(resolve, FONT_WAIT_LIMIT);
    })
]).then(handleRender, handleRender);
